import { LanguageTextItems } from 'services';
import { tokenAuthApiInstance } from 'utils/auth';
import { Logger } from 'utils/logger';

import { PROXY_REQUEST_CONFIG } from './constants';

export type ProxyRequestConfigType = {
  proxyTermsandAgreementText: Array<LanguageTextItems>;
};

export type ProxyRequestConfigResponse = ProxyRequestConfigType;

// this is now coming from the admin portal
export const getProxyRequestConfig = async (): Promise<ProxyRequestConfigResponse | undefined> => {
  try {
    const response = await tokenAuthApiInstance.authAxios().get(PROXY_REQUEST_CONFIG);
    if (response && response.data) {
      const { proxyRequestItems } = response.data;
      return proxyRequestItems;
    }
    return undefined;
  } catch (error) {
    Logger.error(error);
    throw error;
  }
};
